import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { DRAFT_PICK_SLIDE_HEIGHT } from '../../styles';

type WithAccentColor = {
    $accentColor: string;
};

type WithIsActive = WithAccentColor & {
    $isActive: boolean;
};

export const DRAFT_PICK_SLIDE_WIDTH = 230;

export const DraftPickContainer = styled.div`
    height: ${DRAFT_PICK_SLIDE_HEIGHT}px;
    width: ${DRAFT_PICK_SLIDE_WIDTH}px;
    padding-right: 8px;
    user-select: none;

    ${BaseStyle.Mixins.screenSizes.large} {
        user-select: auto;
    }
`;

export const InnerDraftPick = styled.div<WithIsActive>`
    height: 100%;
    width: 100%;
    border-radius: 8px;
    padding: 8px;

    ${({ theme, $accentColor, $isActive }) =>
        $isActive
            ? css`
                  border: 2px solid ${$accentColor || theme.Utility.accent};
              `
            : css`
                  border: 1px solid ${theme.Surface.border};
              `};
`;

export const PickChipRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    overflow: visible;
`;

export const PickChip = styled.div<WithIsActive>`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}

    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    min-width: 48px;
    padding: 0 6px;
    border-radius: 4px;

    ${({ theme, $accentColor, $isActive }) =>
        $isActive
            ? css`
                  background-color: ${$accentColor || theme.Utility.accent};
                  color: ${theme.Text.OppositeSurface.primary};
              `
            : css`
                  background-color: ${theme.Surface.tertiary};
                  color: ${theme.Text.primary};
              `};
`;

export const ActivityIndicatorContainer = styled.div`
    width: 40px;
`;

export const TeamAndPick = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall}

    display: flex;
    flex-direction: row;
    align-items: start;

    .team-display-container {
        flex: initial;

        svg {
            width: 48px;
        }
    }
`;

export const Pick = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Position = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}

    margin-top: 4px;
    color: ${({ theme }) => theme.Text.secondary};
`;

export const OnTheClock = styled(Position)<WithAccentColor>`
    color: ${({ theme, $accentColor }) => $accentColor || theme.Utility.accent};
`;

export const Forfeited = styled(Position)`
    color: ${({ theme }) => theme.Utility.critical};
`;
